import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as InvoiceActions } from '~/store/ducks/invoice';
import api from '~/services/api';
import { sendAttachmentValidate } from '~/components/layout/Logistic/Attachment'
import ModalWarningAttachments from '~/components/layout/Logistic/ModalWarningAttachments';


import {
  Container,
  CardOrder,
  MainContainer
} from '~/components/layout/Logistic/styles';
import {
  TitlePage as IconsTop,
  CloseIconStyled as IconStyled,
  Title,
  HeaderMessage,
  CardInputItem,
  ButtonDivision,
  LoadingIcon,
  PageTitleContainer,
  PageIcon,
  PageTitle,
  BankSlipsContainer,
  PageTitleItem,
  WrapperBankslips,
  DesktopWrapper,
  MobileWrapper,
  MessageNothing,
  BankslipMessage,
} from './styles';
import close from '~/assets/images/close.png';
import '~/components/styles/Global.css';
import { InfoButton } from '~/components/layout/Buttons';
import { verifyRoles } from '~/utils/functions/verifyRoles';
import Loading from '~/components/layout/Loading';
import OpenChatBot from '~/components/layout/Chatbot';
import DesktopPayDebt from '~/components/pages/Logistic/PayDebt/PayDebtDesktop';
import MobilePayDebt from '~/components/pages/Logistic/PayDebt/PayDebtMobile';
import ModalBankslipsDesktop from '~/components/pages/Bankslips/ModalBankslipsDesktop';
import ModalBankslipMobile from '~/components/pages/Bankslips/ModalBankslipsMobile';
import AttachmentProgressBar from '~/components/layout/Logistic/AttachmentProgressBar';
import ProgressButton from '~/components/layout/ProgressButton';

function PayDebt() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [bankSlips, setBankSlips] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalMobile, setOpenModalMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [showButton, setShowButton] = useState([])
  const [modalCancel, setModalCancel] = useState(false);
  const roles = useSelector(state => state.rolesReducer.roles);
  const logisticPaymentReducer = useSelector(state => state.logisticPaymentReducer);
  const refsBankSlips = useRef({});

  useEffect(() => {
    const storeInfoCode = localStorage.getItem('codeStore').split('-');
    setLoading(true);
    requestInvoices(storeInfoCode, true, 0 );
  }, []);

  const requestInvoices = async (
    storeInfo,
    offsetOption,
    offsetValue,
    ) => {
    const customerCode = storeInfo[0];

    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };

    const parameters = {
      method: 'GET',
      headers: header,
    };

    const status = 'VENCIDO'
    const url = `industrial/invoice/v1/installments?customer-code=${customerCode}&_expand=invoice&_limit=100&status=${status}&_offset=${offsetOption ? offsetValue : offsetValue - 1}`

    try {
      const res = await api.get(url, parameters)
      if (res.status === 200) {
          const bankSlipsArray = res.data;
          const bankSlipsGreaterThanZeros = bankSlipsArray.filter(item => item.amountRemaining > 0 && item.paymentStatus === 'OP') ;

          dispatch({ type: "SET_BANKSLIPS", bankSlips: bankSlipsGreaterThanZeros });
          setBankSlips(bankSlipsGreaterThanZeros);
      }
    } catch (erro) {
      toast.error("Não foi possível consultar os débitos anteriores. Por favor, tente novamente ou acione o SAP Local.")

      setTimeout(() => {
        history.push('/portal')
      }, 3500);

    }
    setLoading(false);
  };

  function handleOpenModal(bankSlip) {
    dispatch({
      type: 'invoice/GET_MODAL_INFORMATION',
      modalInformation: bankSlip,
    });
    setOpenModal(!openModal);
  }

  function handleOpenModalMobile(bankSlip) {
    dispatch({
      type: 'invoice/GET_MODAL_INFORMATION',
      modalInformation: bankSlip,
    });
    setOpenModalMobile(!openModalMobile);
  }


const handleShowButton = (props) => {
  setShowButton((oldState)=> {
    const showButtonFilter = oldState.filter(item => item.id !== props.id)
    return [...showButtonFilter, {id: props.id, status: props.status}]
  })
}

const hideButton = showButton.filter(item => item.status === false);

const attachmentCount = useMemo(() => {
  return showButton.length - hideButton.length;
}, [hideButton, showButton]);

const handleFinishButton = async (e) => {
  if (hideButton.length > 0) {
    const errorButton = showButton.find(item => item.status === false);
    if (errorButton) {
      setTimeout(() => {
        refsBankSlips.current[errorButton.id].scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
      }, 100)
    }
    toast.warn((
      <span>
        É necessário anexar todos os comprovantes!
        <br/>
        Comprovantes Anexados: <b>{attachmentCount}</b> de <b>{showButton.length}</b>
      </span>));
    return;
  }
  await sendAttachmentValidate(logisticPaymentReducer.order.id, setLoadingConfirm);
  history.push('/portal')
}

return (
  <Container>
    {openModal ? (
      <ModalBankslipsDesktop close={() => setOpenModal(!openModal)} />
    ) : openModalMobile ? (
      <ModalBankslipMobile
        close={() => setOpenModalMobile(!openModalMobile)}
      />
    ) :
    verifyRoles(roles, 'STATUS_DO_PEDIDO') ? (
      <>
        <IconsTop>
          <div />
          <IconStyled
            src={close}
            alt="Ícone de fechar"
            onClick={() => setModalCancel(true)}
          />
        </IconsTop>
        {loadingPage ? (
          <Loading loadingColor={'white'} />
        ) : (
          <CardOrder>
            <MainContainer>
              <Title>
                <span>Pagar Débitos Anteriores</span>
              </Title>
              <CardInputItem>
                <Row>
                  <Col>
                    <Row>
                      <HeaderMessage>
                        Para seguir com seu pedido, é necessário quitação dos valores abaixo.
                        Após pagamento, não se esqueça de "Anexar Comprovante" para cada um dos valores, separadamente.
                      </HeaderMessage>
                    </Row>
                  </Col>
                </Row>
              </CardInputItem>
              <WrapperBankslips>
                <PageTitleContainer>
                  <PageTitleItem>
                    <PageIcon className="mdi mdi-barcode mr-2" />
                    <PageTitle>Boletos</PageTitle>
                  </PageTitleItem>
                </PageTitleContainer>
                { showButton.length > 0 && (
                  <AttachmentProgressBar
                    total={showButton.length}
                    value={attachmentCount}
                    title="Comprovantes Anexados:"
                    countType="LABEL"
                  />
                )}
                {loading ? (
                  <Loading />
                ) : bankSlips.length < 1 ? (
                  <BankslipMessage>
                    <span>Os valores vencidos não estão disponíveis para visualização no Map. <br/>
                          Entre em contato com o SAP local para identificá-los e seguir com a quitação dos débitos.
                    </span>
                    <span></span>
                  </BankslipMessage>
                ) : (
                  <BankSlipsContainer>
                    {loading ? (
                        <Loading />
                    ) : (
                    <DesktopWrapper>
                      {bankSlips.map((bankSlip, index) => (
                        <div ref={el => refsBankSlips.current[bankSlip.invoice.invoiceId] = el}>
                          <DesktopPayDebt
                            data={bankSlip}
                            key={index}
                            openModal={() =>  handleOpenModal(bankSlip)}
                            handleShowButton={handleShowButton}
                          />
                        </div>
                      ))}
                    </DesktopWrapper>
                    )}
                    <MobileWrapper>
                      {bankSlips.map((bankSlip, index) => (
                        <div ref={el => refsBankSlips.current[bankSlip.invoice.invoiceId] = el}>
                          <MobilePayDebt
                            data={bankSlip}
                            key={index}
                            openModal={() => handleOpenModalMobile(bankSlip)}
                            handleShowButton={handleShowButton}
                          />
                        </div>
                      ))}
                    </MobileWrapper>
                    {bankSlips.length === 0 && (
                      <MessageNothing>
                        Nenhum resultado encontrado
                      </MessageNothing>
                    )}
                  </BankSlipsContainer>
                )}
              </WrapperBankslips>
              {bankSlips.length > 0 && !loading && (
                <ButtonDivision onClick={handleFinishButton}>
                  { hideButton.length > 0 ? (
                  <ProgressButton text="Comprovantes Anexados:"
                    value={attachmentCount}
                    total={showButton.length}/>
                ) : (
                  <InfoButton style={{ margin: "-1rem 0 1rem 0" }} disabled={loadingConfirm}>
                    {loadingConfirm ? (
                      <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <div>Finalizar</div>
                    )}
                  </InfoButton>
                )}
                </ButtonDivision>
              )}
            </MainContainer>
            <OpenChatBot backgroundColor={'#00f3ff'} />
          </CardOrder>
        )}
        <ModalWarningAttachments
          modalWarning={modalCancel}
          setModalWarning={setModalCancel}
        />
      </>
    ) : (
      <Redirect to="/portal" />
    )}
  </Container>
)}

const mapStateToProps = (state) => ({
  modalInformation: state.invoiceReducer.modalInformation,
  access_token: state.loginReducer.access_token,
  login_email: state.loginReducer.login_email,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(InvoiceActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PayDebt);


